module.exports = "<div id=\"batteryGaugeChart\" style=\"width: 100%; height: 100%;\"></div>"